/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Accountingcategory_Statistical12Inputs */



/**

* @param {_Field__Enum_Accountingcategory_Statistical12Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_accountingcategory_statistical12 = /** @type {((inputs?: _Field__Enum_Accountingcategory_Statistical12Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Accountingcategory_Statistical12Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Statistisch")
});
export { _field__enum_accountingcategory_statistical12 as "_field__enum_accountingCategory_STATISTICAL" }